import { MutationKey, QueryKey } from '@tanstack/react-query';

export const cloudFunctionsQueryKeys: QueryKey = ['cloud-functions', 'query'];

export const createCloudFunctionMutationKey: MutationKey = ['cloud-function', 'create'];
export const updateCloudFunctionMutationKey: MutationKey = ['cloud-function', 'update'];
export const deleteCloudFunctionMutationKey: MutationKey = ['cloud-function', 'delete'];
